import { render, staticRenderFns } from "./PriceNew.vue?vue&type=template&id=4aea4164&"
import script from "./PriceNew.vue?vue&type=script&lang=js&"
export * from "./PriceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports